export interface RecordTabBounds {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly bottomY: number;
}

export interface RectLayout {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export interface TextLayout {
  readonly x: number;
  readonly y: number;
  readonly width: number;
}

export interface RecordRowLayout {
  readonly frame: RectLayout;
  readonly trigger: TextLayout;
  readonly title: TextLayout;
  readonly preview: TextLayout;
  readonly replayButton: RectLayout;
}

export interface RecordTabLayout {
  readonly title: { readonly x: number; readonly y: number };
  readonly empty: TextLayout;
  readonly scroll: RectLayout;
  readonly rows: readonly RecordRowLayout[];
  readonly contentHeight: number;
}

export const RECORD_ROW_H = 74;
export const RECORD_ROW_GAP = 8;
export const RECORD_REPLAY_BUTTON_W = 86;
export const RECORD_REPLAY_BUTTON_H = 32;

const HEADER_H = 24;
const LIST_TOP_GAP = 6;
const SIDE_PAD = 8;
const ROW_PAD = 10;
const SCROLLBAR_GUTTER = 18;
const BUTTON_GAP = 10;

export function resolveRecordTabLayout(bounds: RecordTabBounds, rowCount: number): RecordTabLayout {
  const count = Math.max(0, Math.floor(rowCount));
  const scrollY = bounds.y + HEADER_H + LIST_TOP_GAP;
  const scroll: RectLayout = {
    x: bounds.x,
    y: scrollY,
    width: bounds.width,
    height: Math.max(80, bounds.bottomY - scrollY - 6),
  };
  const rowW = Math.max(220, scroll.width - SCROLLBAR_GUTTER);
  const textW = Math.max(80, rowW - ROW_PAD * 2 - RECORD_REPLAY_BUTTON_W - BUTTON_GAP);

  return {
    title: { x: bounds.x + bounds.width / 2, y: bounds.y },
    empty: {
      x: bounds.x + SIDE_PAD,
      y: scrollY + 18,
      width: Math.max(1, bounds.width - SIDE_PAD * 2),
    },
    scroll,
    rows: Array.from({ length: count }, (_, i) => {
      const y = i * (RECORD_ROW_H + RECORD_ROW_GAP);
      const frame: RectLayout = { x: 4, y, width: rowW, height: RECORD_ROW_H };
      const textX = frame.x + ROW_PAD;
      const buttonX = frame.x + frame.width - ROW_PAD - RECORD_REPLAY_BUTTON_W;
      return {
        frame,
        trigger: { x: textX, y: y + 10, width: textW },
        title: { x: textX, y: y + 29, width: textW },
        preview: { x: textX, y: y + 49, width: textW },
        replayButton: {
          x: buttonX,
          y: y + (RECORD_ROW_H - RECORD_REPLAY_BUTTON_H) / 2,
          width: RECORD_REPLAY_BUTTON_W,
          height: RECORD_REPLAY_BUTTON_H,
        },
      };
    }),
    contentHeight: count <= 0 ? 0 : count * RECORD_ROW_H + (count - 1) * RECORD_ROW_GAP + 4,
  };
}
